import React, { useContext, useEffect, useState } from "react";
import { AppContextType, WonmovContext } from "@/context/app-context";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { userRepo } from "@/repo/user-repo";
import TextField from "@/component/widgets/text-field";
import SelectField from "@/component/widgets/select-field";
import TextareaField from "@/component/widgets/textarea-field";
import LoadingGif from "@public/img/loading.gif";

export default function Page() {
    var routeParams = useParams<{ id: string }>();
    var id = routeParams.id || "";
    var setNotification = useContext<AppContextType>(WonmovContext).setNotification;
    var pageLoadingState = useState(true);
    var pageLoading = pageLoadingState[0];
    var setPageLoading = pageLoadingState[1];
    var isLoadingState = useState(false);
    var isLoading = isLoadingState[0];
    var setIsLoading = isLoadingState[1];
    var nameState = useState("");
    var name = nameState[0];
    var setName = nameState[1];
    var descriptionState = useState("");
    var description = descriptionState[0];
    var setDescription = descriptionState[1];
    var typeState = useState<"public" | "private" | undefined>(undefined);
    var type = typeState[0];
    var setType = typeState[1];
    var history = useHistory();

    useEffect(function () {
        setPageLoading(true);
        userRepo.getList(Number(id)).then(function (res) {
            if (res.status && res.data) {
                setName(res.data.name ? res.data.name : "");
                setDescription(res.data.description ? res.data.description : "");
                setType(res.data.is_public ? "public" : "private");
            }
            setPageLoading(false);
        });
    }, [id]);

    var handleSubmit = function () {
        if (isLoading) {
            return;
        }
        if (!name) {
            setNotification({ type: "danger", message: "نام لیست را وارد کنید" });
            return;
        }
        if (!description) {
            setNotification({ type: "danger", message: "توضیحات لیست را وارد کنید" });
            return;
        }
        if (!type) {
            setNotification({ type: "danger", message: "نوع لیست را انتخاب کنید" });
            return;
        }
        setIsLoading(true);
        userRepo.updateList(Number(id), name, description, type === "public").then(function (res) {
            if (!res.status) {
                setNotification({ type: "danger", message: res.message });
                setIsLoading(false);
                return;
            }
            setNotification({ type: "success", message: "لیست با موفقیت ویرایش شد" });
            setIsLoading(false);
            history.replace("/profile/lists/");
        });
    };

    if (pageLoading) {
        return (
            <div className="profile-panel">
                <div className="profile-lists__loading">
                    <img src={LoadingGif} alt="loading" />
                </div>
            </div>
        );
    }

    return (
        <div className="profile-panel profile-lists-form">
            <h2 className="profile-panel__title">ویرایش لیست</h2>

            <div className="profile-edit__form">
                <div className="profile-edit__field">
                    <TextField
                        name="name"
                        value={name}
                        placeholder="نام لیست"
                        onChange={function (e) {
                            setName(e.target.value);
                        }}
                    />
                </div>
                <div className="profile-edit__field">
                    <SelectField
                        uniqueKey="type"
                        value={type || ""}
                        options={[
                            { label: "انتخاب نوع", value: "" },
                            { label: "عمومی", value: "public" },
                            { label: "خصوصی", value: "private" },
                        ]}
                        onChange={function (value) {
                            setType(value as "public" | "private");
                        }}
                    />
                </div>
                <div className="profile-edit__field profile-edit__field--full">
                    <TextareaField
                        name="description"
                        value={description}
                        placeholder="توضیحات لیست"
                        onChange={function (e) {
                            setDescription(e.target.value);
                        }}
                    />
                </div>
                <div className="profile-edit__actions">
                    <button
                        type="button"
                        className="profile-edit__submit"
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? <div className="loader"></div> : "ویرایش لیست"}
                    </button>
                </div>
            </div>
        </div>
    );
}
